<div class="top-header">
  <lib-header
    [title]="''"
    #headerRef
    [user]="userName"
    (darkModeToggle)="onDarkModeToggle()"
    [isDarkMode]="isDarkMode"
    [logoUrl]="logoUrl"
    [showToggle]="false"
    [showLogout]="false"
    [showSystemDate]="false"
    [showSearch]="true"
    [searchPlaceholder]="'Buscar'"
    (search)="onGlobalSearch($event)"
    [showNotifications]="true"
    [notificationCount]="notificationCount()"
    (notificationsClick)="onNotificationsClick()"
    (profileClick)="showMenu(headerRef)"
    (logout)="onLogout()"
  ></lib-header>

  @if (showSearchResults()) {
    <div class="global-search-overlay" role="listbox">
      @if (searchResults().length > 0) {
        <div class="gs-title">
          {{ searchResults().length }}
          {{ searchResults().length === 1 ? 'resultado' : 'resultados' }}
        </div>
        <div class="gs-list">
          @for (r of searchResults(); track r.route) {
            <button class="gs-item" type="button" (click)="onSelectSearchResult(r)">
              <lucide-icon class="gs-item-icon" [name]="r.icon"></lucide-icon>
              <span class="gs-item-text">
                <span class="gs-item-title">{{ r.label }}</span>
                @if (r.group) {
                  <span class="gs-item-group">{{ r.group }}</span>
                }
              </span>
            </button>
          }
        </div>
      } @else {
        <div class="gs-empty">No se encontraron opciones</div>
      }
    </div>
  }

  @if (searchToast()) {
    <div class="gs-toast" role="status" aria-live="polite">{{ searchToast() }}</div>
  }

  <button
    #triggerButton
    [matMenuTriggerFor]="profileMenu"
    class="menu-trigger-hidden"
    aria-hidden="true"
    tabindex="-1"
    type="button"
  >
    Menu
  </button>

  <mat-menu #profileMenu="matMenu" [overlapTrigger]="false" yPosition="below" xPosition="before">
    <div class="perfil-menu-header" (click)="$event.stopPropagation()">
      @if (userFullName()) {
        <div class="perfil-menu-name">{{ userFullName() }}</div>
      }
      <div class="perfil-menu-login">{{ userName }}</div>
      @if (userRoles()) {
        <div class="perfil-menu-roles">{{ userRoles() }}</div>
      }
    </div>
    <div class="perfil-menu-sep"></div>
    @for (item of itemsProfileMenu; track item.id) {
      <button mat-menu-item (click)="onProfileAction(item)" type="button">
        {{ item.action }}
      </button>
    }
  </mat-menu>
</div>
